import {CropRotate, ViewInAr, PieChart, Code, BarChart, CloudOutlined, FavoriteBorder, Public, PersonOutlined, AddLocationAltOutlined, PhoneIphone, EmailOutlined, Facebook, Twitter, Instagram, YouTube, LinkedIn,Medium, GitHub,CreateIcon } from "@mui/icons-material"

export const navlink = [
  {
    url: "/",
    text: "Home",
  },
  {
    url: "/about",
    text: "About",
  },
  {
    url: "/services",
    text: "Services",
  },
  {
    url: "/portfolio",
    text: "Portfolio",
  },
  {
    url: "/testimonials",
    text: "Testimonials",
  },
  {
    url: "/education",
    text: "Education",
  },
  {
    url: "/certificates",
    text: "Certificates",
  },
  {
    url: "/blog",
    text: "Blog",
  },
  {
    url: "/contact",
    text: "Contact",
  },
]
export const home = [
  {
    text: "HELLO I'M",
    name: "Heshan Umayanga",
    post: "Software Engineer Intern",
    design: "Java Developer",
    desc: "A passionate BackEnd Developer. I have been working in the Java SpringBoot BackEnd Development. who is following bTech in Software Technology from University of Vocational Technology Ratmalana and Bsc Hons Computer Science in University of People"
  },
]
export const about = [
  {
    desc: "A passionate BackEnd Developer. I have been working in the Java SpringBoot BackEnd Development. who is following bTech in Software Technology from University of Vocational Technology Ratmalana and Bsc Hons Computer Science in University of People",
    desc1: "FullStack(React/Angular/SpringBoot) Developer",
    cover: "../images/man.jpeg",
  },
]
export const services = [
  
  {
    id: 2,
    icon: <CropRotate />,
    title: "APIs using SpringBoot",
    desc: "Lorem Ipsum simply text of the printing and type setting industry when an unknown printing simply",
  },
  {
    id: 3,
    icon: <ViewInAr />,
    title: "Responsive Design",
    desc: "Lorem Ipsum simply text of the printing and type setting industry when an unknown printing simply",
  },
  {
    id: 4,
    icon: <PieChart />,
    title: "Material UI	",
    desc: "Lorem Ipsum simply text of the printing and type setting industry when an unknown printing simply",
  }
]
export const project = [
  {
    id: 1,
    icon: <CloudOutlined />,
    num: "89",
    title: "HAPPY CLIENTS",
  },
  {
    id: 2,
    icon: <FavoriteBorder />,
    num: "231",
    title: "PROJECTS COMPLEATED",
  },
  {
    id: 3,
    icon: <Public />,
    num: "108",
    title: "FILES DOWNLOADED",
  },
  {
    id: 4,
    icon: <PersonOutlined />,
    num: "1446",
    title: "LIENS OF CODE",
  },
]
export const portfolio = [
  // {
  //   id: 1,
  //   cover: "../images/port/port1.jpg",
  //   name: "Brand",
  //   category: "marketing",
  //   title: "Brex Logo",
  // },
  // {
  //   id: 2,
  //   cover: "../images/port/port2.jpg",
  //   name: "Brand",
  //   category: "design",
  //   title: "Brex Logo",
  // },
  // {
  //   id: 3,
  //   cover: "../images/port/port3.jpg",
  //   name: "Brand",
  //   category: "development",
  //   title: "Brex Logo",
  // },
  // {
  //   id: 4,
  //   cover: "../images/port/port4.jpg",
  //   name: "Brand",
  //   category: "marketing",
  //   title: "Brex Logo",
  // },
  // {
  //   id: 5,
  //   cover: "../images/port/port5.jpg",
  //   name: "Brand",
  //   category: "design",
  //   title: "Brex Logo",
  // },
  // {
  //   id: 6,
  //   cover: "../images/port/port6.jpg",
  //   name: "Brand",
  //   category: "development",
  //   title: "Brex Logo",
  // },
]
export const testimonials = [
  // {
  //   id: 1,
  //   text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam porttitordapibus dictum.Fusce faucibus ligula scelerisque, eleifend turpis in",
  //   image: "./images/testimonials/team-1.png",
  //   name: "Alamin Musa",
  //   post: "Front End Developer",
  // },
  // {
  //   id: 2,
  //   text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam porttitordapibus dictum.Fusce faucibus ligula scelerisque, eleifend turpis in",
  //   image: "./images/testimonials/team-2.png",
  //   name: "Alex Ander",
  //   post: "Back End Developer",
  // },
  // {
  //   id: 3,
  //   text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam porttitordapibus dictum.Fusce faucibus ligula scelerisque, eleifend turpis in",
  //   image: "./images/testimonials/team-3.png",
  //   name: "GorkCoder",
  //   post: "React Developer",
  // },
]
export const blog = [
  {
    id: 1,
    title: "Code Smells in Software Development- Part 1",
    date: "Oct 2024",
    desc: "This article is to get understand about code smell in software development.You may heard about this before and Let me give you clear understand about how to understand code smell in your code base.I published design patterns,anti patterns in my previous articles,Feel free to check my articles if you don’t have clear understand ,And I highly recommend you to cover those concepts and came back to this code smell article ,it will be wise to followup like I mentioned .",
    link:"https://medium.com/@heshanu97/code-smells-in-software-development-part-1-4e8e9e140818"
  },
  {
    id: 2,
    title: "Anti-patterns in Software Development.",
    date: "Oct 2024",
    desc: "Software anti-patterns are common practices in software development that, despite initially appearing to be a good idea, result in bad consequences or suboptimal solutions.",
    cover: "https://medium.com/@heshanu97/anti-patterns-in-software-development-db723b5159dc",
  },
  {
    id: 3,
    title: "SOLID principles in Software Development.",
    date: "Sept, 2024",
    desc: "This article is for SOILD principles and I use java to implement this concepts.Those are not rules to follow they are best practices to follow to build and develop highly maintainable and loose coupling softwares.In other wordsThe SOLID principles are a set of five design principles intended to make software designs more understandable, flexible, and maintainable. These principles were introduced by Robert C. Martin, also known as “Uncle Bob,” and are fundamental to object-oriented design.",
    cover: "https://medium.com/@heshanu97/solid-principles-in-software-development-a730f33395a6",
  },
  {
    id: 4,
    title: "Design Pattern Article Series",
    date: "Sept, 2024",
    desc: "Hi All , This article is to get understand Factory design pattern using Head First Design book.It is in 4th chapter on this book,Sometime this pattern little confused to me.But Let’s get help from book and clarify doubts",
    cover: "https://medium.com/@heshanu97/comprehensive-guide-on-the-factory-pattern-inspired-by-the-head-first-design-patterns-book-cb7acfb32956",
  },

]
export const contact = [
  {
    icon: <AddLocationAltOutlined />,
    text1: "297/2,Majuwana Rd,Gonapinuwala",
    text2: "80230",
  },
  {
    icon: <PhoneIphone />,
    text1: "0775163610"
  },
  {
    icon: <EmailOutlined />,
    text1: "heshanu97@gmail.com"
  },
]

export const education=[
  {
    id: 1,
    title: "Undergradute from UOVT(following)",
    desc: "BTech(Hons) in Software Technology Current GPA 3.25",
    img:"./images/edu/uovt.png"
  },
  {
    id: 2,
    title: "Undergradute from UofPeople(following)",
    desc: "Bsc in Computer Science(online)",
    img:"./images/edu/uop.png"
  }
]

export const certificates=[
  {
    id: 1,
    title: "Google Analytics",
    img:"./images/certs/ganal.png"
  },
  {
    id: 2,
    title: "Microsoft Azure Foundamentals(AZ-900)",
    img:"./images/certs/maz.png"
  },
  {
    id: 3,
    title: "Microsoft Azure Foundamentals(AI-900)",
    img:"./images/certs/mai.png"
  },
  {
    id: 4,
    title: "Microsoft Azure Data Foundation(DP-900)",
    img:"./images/certs/mdp.png"
  },
{
  id: 5,
  title: "Meta BackEnd Developer",
  img:"./images/certs/metaB.png"
},
{
  id: 6,
  title: "Meta FullStack Developer",
  img:"./images/certs/metaF.png"
},
{
  id: 7,
  title: "See More",
  img:"./images/certs/mdp.png"
},
]
export const social = [
  {
    icon: <LinkedIn/>,
    link:"https://www.linkedin.com/in/heshanu/"
  },
  
  {
    icon:<Code/>,
    link:"https://heshanu97.medium.com/"
  },{
    icon:<GitHub/>,
    link:"https://github.com/heshanu"
  }
]
